export default __webpack_public_path__ + "static/media/url.c0f54b1b.svg";